import React from "react";
import PropTypes from "prop-types";
import BarCountdownTimer from "./BarCountdownTimer";
import PriceChangeIndicator from "./PriceChangeIndicator";
import RenkoBrickSizeIndicator from "./RenkoBrickSizeIndicator";
import PointAndFigureBoxIndicator from "./PointAndFigureBoxIndicator";

/**
 * ChartBottomIndicators - Container for bottom-left chart indicators
 *
 * Positions countdown timer, price change, and renko indicator dynamically
 * using flexbox, so they flow naturally based on their content width.
 */
const ChartBottomIndicators = ({
  chartId,
  chartData,
  periodicity,
  chartType,
  showCountdown,
  showPriceChange,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "35px",
        left: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        zIndex: 100,
      }}
    >
      {showCountdown && (
        <BarCountdownTimer
          chartData={chartData}
          periodicity={periodicity}
          inline={true}
        />
      )}
      {chartType === "renko" && (
        <RenkoBrickSizeIndicator
          chartId={chartId}
          chartData={chartData}
          periodicity={periodicity}
          inline={true}
        />
      )}
      {chartType === "pointfigure" && (
        <PointAndFigureBoxIndicator
          chartId={chartId}
          chartData={chartData}
          inline={true}
        />
      )}
      {showPriceChange && (
        <PriceChangeIndicator
          chartData={chartData}
          periodicity={periodicity}
          inline={true}
        />
      )}
    </div>
  );
};

ChartBottomIndicators.propTypes = {
  chartId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  chartData: PropTypes.array,
  periodicity: PropTypes.string,
  chartType: PropTypes.string,
  showCountdown: PropTypes.bool,
  showPriceChange: PropTypes.bool,
};

export default ChartBottomIndicators;
